import StatCharts from "./StatCharts";
export default StatCharts;
